import {
    UserController,
    ProductController,
    StripeController,
} from "controllers";

export const getProducts = async (market) => {
    const lateBoxes = await ProductController.getLateBoxes(market);
    return lateBoxes;
};

export const chargeLateBox = async (lateBox, country) => {
    try {
        await updateAllStatuses(lateBox, "charge");

        await addStripeFields(lateBox, country);
    } catch (error) {
        throw new Error(error.message);
    }
}

export const exemptLateBox = async (lateBox, country) => {
    try {
        await updateAllStatuses(lateBox, "exempt");

        await addStripeFields(lateBox, country);
    } catch (error) {
        throw new Error(error.message);
    }
}
const updateAllStatuses = async (lateBox, action) => {
    const timestamp = +new Date();
    const payload = (action === 'charge') ? { is_charged: true } : { exempted: timestamp };
    await ProductController.updateBoxInfo(lateBox.user.id, lateBox.id, payload);
}

const addStripeFields = async (lateBox, country) => {
    const stripe = lateBox.user?.stripe;
    // add the stripe fields
    if (!stripe.late_box_subscriptions) {
        stripe.late_box_subscriptions = [];
    }
    try {
        const lateBoxPayload = await createBoxPayload(lateBox, stripe, country);
        stripe.late_box_subscriptions.push(lateBoxPayload);
        const payload = { stripe };
        await UserController.addStripeSubscription(lateBox.user.id, payload);
    } catch (error) {
        console.error(error);
    }
}

export const createBoxPayload = async (lateBox, stripe, country) => {
    const lateBoxPayload = { box_id: lateBox.id };
    const customerId = stripe.stripe_id;
    if (customerId) {
        const result = await StripeController.createLateBoxSubscription(customerId, country);
        const subResult = result.data.result;

        lateBoxPayload.subscription_id = subResult.id;
        lateBoxPayload.status = subResult.status;
        lateBoxPayload.created_at = subResult.created;
        lateBoxPayload.created_from = 'Tidie';
    }
    return lateBoxPayload;
}

export const getBoxesByUsers = async (activeTab, field, search, market) => {
    const option = activeTab.toLowerCase();
    try {
        const users = await UserController.filterUsersByField(field, search, market);
        let results = [];
        for (const user of users) {
            const result = await ProductController.getItemsByFieldQuery({ option, search: user.id, market });
            results.push(...result);
        };

        if (results.length !== 0) {
            results = await getLogs(results);
        };
        return results;
    } catch (error) {
        throw new Error(error.message);
    };
}
